module.exports = __webpack_public_path__ + "img/Under 18 Icon - charcoal.c36f5d2b.svg";